'use client';
import { motion } from 'framer-motion';
import React from 'react';

const StrokeBet = ({ color }: any) => {
  // const mainColor = colors[color % 4] || '#D3A300';
  const mainColor = color;

  return (
    <div className='strokeBet h-full w-full'>
      <div className='flex items-center justify-between'>
        <motion.svg
          initial={{
            scale: 1,
          }}
          animate={{
            scale: [1.2, 1.6, 1.4, 1.6, 1.1],
          }}
          transition={{
            duration: 0.5,
            times: [0, 0.4, 0.5, 0.8, 1],
            ease: 'easeInOut',
            delay: 2,
          }}
          className='absolute left-0 top-0'
          width='100'
          height='56'
          viewBox='0 0 100 56'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M0 10.1644V19.5469L2.79935 22.6744V11.7282L10.4976 3.12755L93.8941 3.12751L99.4928 9.38252V5.47314L94.5939 0L9.09789 3.65371e-05L0 10.1644Z'
            fill={mainColor}
          />
          <path
            d='M2.74132 26.4531H1.37061V38.5461L2.74132 40.0578V26.4531Z'
            fill={mainColor}
            fill-opacity='0.5'
          />
          <path
            d='M2.74132 41.5693H1.37061V53.6624L2.74132 55.174V41.5693Z'
            fill={mainColor}
            fill-opacity='0.5'
          />
        </motion.svg>

        <motion.svg
          initial={{
            scale: 1,
          }}
          animate={{
            scale: [1.2, 1.6, 1.4, 1.6, 1.1],
          }}
          transition={{
            duration: 0.5,
            times: [0, 0.4, 0.5, 0.8, 1],
            ease: 'easeInOut',
            delay: 2,
          }}
          className='absolute right-0 top-[7px]'
          width='21'
          height='22'
          viewBox='0 0 21 22'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M12.7757 3.20057H1.80993H0.439209L3.18064 0.0693359H14.1464L21 7.89741V18.8567L18.2585 21.9879V9.46302L16.8878 7.89741L12.7757 3.20057Z'
            fill={mainColor}
            fill-opacity='0.3'
          />
        </motion.svg>
      </div>
      <div className='absolute bottom-0 mt-auto flex w-full items-center justify-between'>
        <motion.svg
          initial={{
            scale: 1,
          }}
          animate={{
            scale: [1.2, 1.6, 1.4, 1.6, 1.1],
          }}
          transition={{
            duration: 0.5,
            times: [0, 0.4, 0.5, 0.8, 1],
            ease: 'easeInOut',
            delay: 2,
          }}
          width='54'
          height='100'
          viewBox='0 0 54 100'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M0 85.3054V0.232422L2.81358 4.87277V83.7586L14.7713 96.9063H53.4579L50.6444 99.9999H13.3645L0 85.3054Z'
            fill={mainColor}
          />
        </motion.svg>

        <motion.svg
          initial={{
            scale: 1,
          }}
          animate={{
            scale: [1.2, 1.6, 1.4, 1.6, 1.1],
          }}
          transition={{
            duration: 0.5,
            times: [0, 0.4, 0.5, 0.8, 1],
            ease: 'easeInOut',
            delay: 2,
          }}
          className='absolute bottom-0 right-0'
          width='47'
          height='96'
          viewBox='0 0 47 96'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M46.9998 81.3834V52.9189L44.2174 57.5348V79.8448L32.3924 92.9231H3.87333L0.395393 96.0003H33.7836L46.9998 81.3834Z'
            fill={mainColor}
          />
          <path
            d='M46.3144 48.3838L46.9998 48.3838L46.9998 35.6189L46.3144 34.0233L46.3144 48.3838Z'
            fill={mainColor}
            fill-opacity='0.5'
          />
          <path
            d='M46.3144 32.5117L46.9998 32.5117L46.9998 2.33315L46.3144 0.0117187L46.3144 32.5117Z'
            fill={mainColor}
            fill-opacity='0.5'
          />
        </motion.svg>
      </div>
    </div>
  );
};

export default StrokeBet;
